import { encodeQueryFilter } from "./utils";
import axios from "../axios";

const EVENTS_URL = "/api/events";

export function fetchEvent(id: string) {
  return axios({
    url: `${EVENTS_URL}/${id}`,
    method: "get",
  });
}

export function fetchEvents(filter?: any) {
  let url = EVENTS_URL;
  if (filter) {
    url += `?filter=${encodeQueryFilter(filter)}`;
  }
  return axios({
    url,
    method: "get",
  });
}

export function fetchEventRegistrationCount(eventIds: string[]) {
  let url = `/api/registrationCount?eventIds=${eventIds.join(
    ","
  )}&datewise=true`;
  return axios({
    url,
    method: "get",
  });
}
